export * from './transloco-loader';
export * from './transloco.module';
